// extracted by mini-css-extract-plugin
export default {"wrapper":"bell_wrapper__GUS71","count":"bell_count__uIDlW","blink":"bell_blink__HwvxK"};